import { render, staticRenderFns } from "./detilKegiatan.vue?vue&type=template&id=01144585&"
import script from "./detilKegiatan.vue?vue&type=script&lang=js&"
export * from "./detilKegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QImg})
